import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import "./style.css";


const WelcomeMessage = ({ accountName }) => {
  return (
    <div className="welcome-message">Welcome to {accountName}'s account</div>
  );
};

const Dashboard = () => {
  const [heading, setHeading] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [date, setDate] = useState("");
  const [image, setImage] = useState(null);
  const history = useHistory();

  const accountName = localStorage.getItem("accountName");
  const [error, setError] = useState([]);
  const [showErrorPopup, setShowErrorPopup] = useState(false);

  const handleLogout = () => {
    const errors = [];
    fetch("https://jacobjose.azurewebsites.net/auth/logout", {
      method: "GET",
    })
      .then((response) => {
        if (response.status === 200) {
          console.info("Successfully logged out.");
        } else {
          console.error("Could not log out.");
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        errors.push("An error occurred. Please try again later.");
        setError(errors);
        setShowErrorPopup(true);
      });
  };

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  const handleImageChange = (e) => {
    const selectedImage = e.target.files[0];
    setImage(selectedImage);
  };

  const handleBlogPost = () => {
    const postData = {
      heading,
      category,
      description,
      date,
      image,
    };

    axios
      .post("https://jacobjose.azurewebsites.net/blog/save", postData)
      .then((response) => {
        console.info("Blog post saved successfully:", response.data);
        handleClose();
        history.push("/blog");
      })
      .catch((error) => {
        console.error("Error while saving the blog post:", error);
        handleClose();
        history.push("/blogs");
      });
  };

  return (
    <div className="dashboard">
      <h4>Welcome to {accountName}'s account</h4>

      <div className="main-menu">
        <nav className="nav_mobile_menu">
          <ul>
            <li>
              <Link to="/Profile" className="widget-button">
                <h2>Profile</h2>
              </Link>
            </li>
            <li>
              <Link to="/" className="widget-button">
                <h2>Blogs</h2>
              </Link>
              <ul className="submenu">
                <li onClick={handleShow}>
                  <div className="submenu-item">Create Blog</div>
                </li>
                <li>
                  <Link to="/DeleteBlog">Delete Blog</Link>
                </li>
                <li>
                  <Link to="/ManageBlog">Manage Blog</Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/AdminSignIn" className="widget-button" onClick={handleLogout}>
                <h2>Logout</h2>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
      {showModal && (
        <div className="modal-overlay">
          <div className="blog-modal">
            <h2>Create Blog Post</h2>
            <input
              type="text"
              placeholder="Blog Header"
              value={heading}
              onChange={(e) => setHeading(e.target.value)}
            />
            <input
              type="date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
            />
            <input
              type="text"
              placeholder="Blog Category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
            />
            <textarea
              placeholder="Blog Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="10"
            />
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
            <div className="button-container">
              <button onClick={handleBlogPost}>Create</button>
              <button onClick={handleClose}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
